module.exports = __webpack_public_path__ + "static/img/09.865c8eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/09.jpg
// module id = mbmL
// module chunks = 0